import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import AudioPlayer from "react-modern-audio-player";

import { FaWindowClose } from "react-icons/fa";

import karbala from "../../assets/images/New folder/bargozide ha/Rajebe Karbala pic.png";
import madar from "../../assets/images/New folder/bargozide ha/hazrat madar.png";
import asir from "../../assets/images/New folder/bargozide ha/asire entezar pic.png";
import chador from "../../assets/images/New folder/bargozide ha/nakhe chador pic.png";
import ReactAudioPlayer from "react-audio-player";

import "./koohrokhi.scss";

export default function PlayerModal({
  showPlayerModal,
  setShowPlayerModal,
  playList,
  setShowAudioPlayer,
}) {

  return (
    <Modal
      show={showPlayerModal}
      size="xl"
      fullscreen="sm-down"
      className="audio-player-modal"
    >
      <Modal.Header>
        <div>البوم انتخاب شده</div>
        <div
          className="cursor-pointer"
          onClick={() => {
            setShowPlayerModal(false);
            setShowAudioPlayer(true);
          }}
        >
          <FaWindowClose color="#fe0000" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center ">
          <AudioPlayer
            playList={playList}
            activeUI={{
              all: true,
            }}
            placement={{
              interface: {
                templateArea: {
                  artwork: "row1-3",
                  playList: "row1-1",
                  trackInfo: "row1-2",
                  trackTimeCurrent: "row2-1",
                  progress: "row2-2",
                  trackTimeDuration: "row2-3",
                  playButton: "row4-2",
                  repeatType: "row4-1",
                  volume: "row4-3",
                },
              },
            }}
            volumeSliderPlacement="left"
            progressType="bar"
            rootContainerProps={{
              colorScheme: "dark",
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}
